module.exports = __webpack_public_path__ + "hero-what-we-do@2x.3zs0lXay.png";